// extracted by mini-css-extract-plugin
export var card = "_4u-0";
export var content = "_4u-1";
export var contentLoading = "_4u-2";